import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import CloseButton from 'react-bootstrap/CloseButton';

const MyModal = (props) => {
  return (
    <>
      <Modal
        show={props.show}
        className="modal modal-v2"
        onHide={props.handleClose}
        animation={false}
      >
        <Modal.Header><CloseButton className="btn-modal-close" onClick={props.handleClose} />
        <Modal.Title>{props.titleText}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {props.bodyText}
        </Modal.Body>
        <Modal.Footer>
          {props.twoButtons && 
            <Button variant="secondary" onClick={props.handleConfirm}>
              Oui
            </Button>
          }
          <Button variant="secondary" onClick={props.handleClose}>
              {props.twoButtons ? "Non" : "Fermer"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default MyModal;
